<template>
  <div class="title">
    <slot></slot>
    <div class="title_div"></div>
  </div>
</template>

<script>
export default {
  name: 'TitleInfo',
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
@import "../assets/style/vars.scss";
.title {
  font-size: 14px;
  color: $btn_search;
  text-align: left;
}
.title_div {
  background-color: #dbe2ed;
  height: 1px;
  margin-top: 2px;
}
</style>
